/* istanbul ignore next */
import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'
import tenantsReducer from 'components/with-tenants/container/reducer'
import usersReducer from 'components/with-users/container/reducer'
import widgetReducer from 'pages/widgets/form-actions/edit/reducer'

// istanbul ignore next
export default combineReducers({
  form: formReducer,
  users: usersReducer,
  tenants: tenantsReducer,
  widget: widgetReducer
})



// WEBPACK FOOTER //
// ./src/reducers.js